export default __webpack_public_path__ + "static/media/gourab.a24905f1.webp";